import { Api } from "api";

export const getPositions = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_positions/?hash_pw=${hash}`);
  return res.data;
};

export const addPosition = async (position: string, info: boolean, min_sum: number) => {
  const hash = localStorage.getItem("hash");
  const addInfo = info !== undefined ? `&access_to_additional_info=${info}` : "";
  const minSum = min_sum !== undefined ? `&min_sum=${min_sum}` : "";
  const res = await Api.post(`/add_position/?hash_pw=${hash}&position=${position}${addInfo}${minSum}`);
  return res.data;
};

export const changePositionStatus = async (position_id: number, status: boolean, info: boolean, min_sum: number) => {
  const hash = localStorage.getItem("hash");
  const addInfo = info !== undefined ? `&access_to_additional_info=${info}` : "";
  const minSum = min_sum !== undefined ? `&min_sum=${min_sum}` : "";
  const url = `/change_position_status/?hash_pw=${hash}&position_id=${position_id}&status=${status}${addInfo}${minSum}`;
  const res = await Api.post(url);
  return res.data;
};
